
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(128|310|414)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
